var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel2Illustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 794 794",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.207 572.336c30.474 0 55.177-24.788 55.177-55.363s-24.703-55.363-55.177-55.363-55.176 24.788-55.176 55.363 24.702 55.363 55.176 55.363z",
    fill: "#F0BE8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M334.257 567.291l-8.329 12.626a90.56 90.56 0 01-99.835 37.879 206.984 206.984 0 01-121.245-93.429 75.61 75.61 0 01.961-78.08l35.557-57.686-26.08-23.464-42.07 56.057a152.174 152.174 0 00-27.949 119.189l42.71 230.37h145.857l-9.13-83.473a147.024 147.024 0 00130.054-78.453l9.503-18.072-30.004-23.464z",
    fill: "#F0BE8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M397.095 554.772L138.056 322.267 354.144 44.783l276.47 233.519-233.519 276.47z",
    fill: "#F26445"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M639.423 270.347l-276.47-233.52 138.088-13.56L757.678 244.16l-118.255 26.187z",
    fill: "#F0BE8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M532.353 541.879l-123.78 16.016 235.014-274.468L760 257.774 532.353 541.879z",
    fill: "#48B7A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel2Illustration);
export default __webpack_public_path__ + "static/media/level-2-illustration.23d5bf5d08207d64c33bc1831b8880dd.svg";
export { ForwardRef as ReactComponent };